module.exports = global["AdaptiveCards"] = require("-!.\\adaptivecards.js");


//////////////////
// WEBPACK FOOTER
// ./~/adaptivecards/lib/adaptivecards.js
// module id = 44
// module chunks = 0